<template>
  <div>
    <el-table :data="listInfo">
      <el-table-column prop="showTime" label="操作时间" ></el-table-column>
      <el-table-column prop="relationSn" label="关联单号"></el-table-column>
      <el-table-column prop="typeName" label="操作类型"></el-table-column>
      <el-table-column prop="changeCoin" label="费用变化（元）" ></el-table-column>
      <el-table-column prop="remark" label="说明"></el-table-column>
      <el-table-column prop="changeAfterCoin" label="费用余额（元）"></el-table-column>
      <el-table-column prop="" label="操作">
        <template slot-scope="{row}">
          <div>
            <el-link class="link" type="primary" :underline="false" @click="openDialog(row)">查看详情</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="tar mt-20">
      <router-link :to="`${basePath}/coinRecordInfo?id=${id}`">
        <el-button type="text" class="width-auto">
          查看所有交易记录
          <i class="el-icon-arrow-right color-b"></i>
        </el-button>
      </router-link>
    </div>
    <DetailsInfo :info="info" :showDialog="dialogVisible" @close="info={},dialogVisible=false" />
  </div>
</template>

<script>
import { axiosApi, basePath } from "~/api/api";
import { parseTime, computeNumber} from "@/utils";
import { getCoinRecordPage } from "~/api/axiosInfo";
import DetailsInfo from "@/components/coin/detailsInfo.vue";

export default {
  name: 'coinRecord',
  props: ['id'],
  components:{
    DetailsInfo
  },
  data(){
    return {
      basePath: basePath,
      listInfo: [],
      dialogVisible:false,
      info:{},
    }
  },
  mounted(){
    this.getList()
  },
  computed:{

  },
  methods:{
    getList(){
      getCoinRecordPage({acctTraderCoinId:this.id,pageIndex:1,pageSize:10}).then(res=>{
        this.listInfo = res.elements.map(item=>{
          item.showTime = parseTime(item.gmtCreate)
          item.changeAfterCoin = computeNumber(item.withdrawCoin,'+',item.changeCoin).result
          return item
        })
      }).catch(err=>{

      })
      
    },
    openDialog(row){
      if(row.type===2){
        sessionStorage.setItem('orderSn', row.relationSn)
        this.$router.push(basePath + '/purchaseOrderDetail?orderSn='+row.relationSn)
      }else if (row.type===3){
        this.$router.push(basePath + "/serviceDetail/" + row.relationSn);
      }else{
        this.info = row
        this.dialogVisible = true
      }
    },
  }
}
</script>

<style lang="less" scoped>

</style>